export default __webpack_public_path__ + "static/logo-10-f7417f4fb91243e9620a49bc0fea37cf.webp";